import PAImage from "component/design-system/images/PAImage";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";

interface IProps{
    dark?: boolean;
    width?: number;
    height?: number;
    className?: string;
}

function VehicleIcon({
  dark = false, width = 30, height = 30, className = "",
}: IProps) {
  return (
    <PAImage
      src={getRelativeImagePath(`/cms/pubicImages/images/vehicle-${dark ? "dark" : "light"}.webp`)}
      alt="Vehicle Icon"
      width={width}
      height={height}
      className={className}
    />
  );
}

export default VehicleIcon;
